import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";
import theme from "../../theme";
import { ButtonWrapperProps, ButtonProps } from "../../@types/";

const ButtonWrapper = (props: ButtonWrapperProps & ButtonProps) => {
  const useStyles = makeStyles(() => ({
    customStyles: {
      color: props.color ? props.color : theme.palette.text.primary,
      backgroundColor: props.bgColor,
      // width: 'auto',
      minHeight: '40px',
    }
  }));
  const classes = useStyles();

  return (
    <>
      <Button
        variant="contained"
        className={`${classes.customStyles} ${props.className}`}
        onClick={props.onClick}
        startIcon={props.icon}
      >
        {props.message}
      </Button>
    </>
  );
};

export default ButtonWrapper;
